var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { sentinelModules } from "../utils/constants";
class ContractVersionUtils {
    constructor(contract) {
        this.contract = contract;
    }
    getContractVersion() {
        return __awaiter(this, void 0, void 0, function* () {
            return this.contract.call("VERSION", []);
        });
    }
    getModules() {
        return __awaiter(this, void 0, void 0, function* () {
            return this.contract.call("getModules", []);
        });
    }
    encodeEnableModule(moduleAddress) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.contract.encode("enableModule", [moduleAddress]);
        });
    }
    encodeDisableModule(moduleAddress) {
        return __awaiter(this, void 0, void 0, function* () {
            const modules = yield this.contract.call("getModules", []);
            const index = modules.findIndex((module) => module.toLowerCase() === moduleAddress.toLowerCase());
            const prevModuleAddress = index === 0 ? sentinelModules : modules[index - 1];
            return this.contract.encode("disableModule", [prevModuleAddress, moduleAddress]);
        });
    }
}
export default ContractVersionUtils;
